import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import type { Article } from '@/types/content';

interface LatestSectionProps {
  articles: Article[];
}

export default function LatestSection({ articles }: LatestSectionProps) {
  return (
    <section aria-labelledby="home-latest">
      <SectionHeading
        eyebrow="Latest Files"
        title="最新爆料档案"
        description="刚刚完成核对的稿件，按发布时间倒序排列。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>
    </section>
  );
}